import { Component, createComponent, ElementRef, Output, Input, EventEmitter, ComponentRef, reflectComponentType, EnvironmentInjector, ApplicationRef, ChangeDetectionStrategy, inject, signal } from '@angular/core'
import { AssetArticleEmbedComponent } from 'src/app/pages/data/asset-sales/asset-article-embed/asset-article-embed.component'
import { SituationArticleEmbedComponent } from 'src/app/pages/situations/situation-article-embed/situation-article-embed.component'
import { CapstructureEmbedComponent } from 'src/app/pages/situations/capstructure-embed/capstructure-embed.component'
import { PlanArticleEmbedComponent } from 'src/app/pages/data/plans/plan-article-embed/plan-article-embed.component'
import { PDFViewerComponent } from '../pdf-viewer/pdf-viewer.component'
import { FollowableLinkComponent } from '../followable-link/followable-link.component'
import { KeipArticleEmbedComponent } from 'src/app/pages/data/keip-kerp/keip-article-embed/keip-article-embed.component'
import { KerpArticleEmbedComponent } from 'src/app/pages/data/keip-kerp/kerp-article-embed/kerp-article-embed.component'
import { SecLinkComponent } from '../sec-link/sec-link.component'
import { CopyToClipboardComponent } from 'src/app/shared/components/copy-to-clipboard/copy-to-clipboard.component'
import { ExportToXlsComponent } from 'src/app/shared/components/export-to-xls/export-to-xls.component'
import { ThumbsCommentComponent } from 'src/app/shared/components/thumbs-comment/thumbs-comment.component'
import { AcknowledgeFeedbackComponent } from 'src/app/shared/components/acknowledge-feedback/acknowledge-feedback.component'

export const embeddedComponents = [
    AssetArticleEmbedComponent,
    SituationArticleEmbedComponent,
    CapstructureEmbedComponent,
    PlanArticleEmbedComponent,
    PDFViewerComponent,
    FollowableLinkComponent,
    KeipArticleEmbedComponent,
    KerpArticleEmbedComponent,
    FollowableLinkComponent,
    SecLinkComponent,
    CopyToClipboardComponent,
    ExportToXlsComponent,
    ThumbsCommentComponent,
    AcknowledgeFeedbackComponent
]

export class EmbeddedComponents {
    components = embeddedComponents
}

@Component({
    selector: 'content-viewer',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    providers:[ EmbeddedComponents ]
})
export class ContentViewer {
    private injector = inject(EnvironmentInjector)
    private appRef = inject(ApplicationRef)

    private hostElement: HTMLElement
    private selectors: [string, any][] = []
    private embeddedComponents: ComponentRef<any>[] = []

    @Output() docRendered = new EventEmitter()

    constructor() {
        const elementRef = inject(ElementRef)
        const embeddedComponents = inject(EmbeddedComponents)

        this.hostElement = elementRef.nativeElement
        embeddedComponents.components.forEach(component => {
            //@ts-ignore
            const metadata = reflectComponentType(component)
            this.selectors.push( [metadata!.selector, component])
        })
    }

    @Input() set content(content:string) {
        this.ngOnDestroy()
        if (content) {
            this.build(content)
            this.docRendered.emit()
        } else {
            this.hostElement.innerHTML = ''
        }
    }

    private build(content:string) {
        this.hostElement.innerHTML = content || ''

        if (!content) { return }

        this.selectors.forEach(([selector, component]) => {
            const embeddedComponentElements = this.hostElement.querySelectorAll(selector)

            //@ts-ignore
            for (const element of embeddedComponentElements) {
                //convert NodeList into an array, since Angular dosen't like having a NodeList passed
                //for projectableNodes
                const projectableNodes = [Array.prototype.slice.call(element.childNodes)]

                const embeddedComponent = createComponent(component, {
                    hostElement : element,
                    environmentInjector: this.injector,
                    projectableNodes
                })
                this.appRef.attachView(embeddedComponent.hostView)

                const componentDef = reflectComponentType(embeddedComponent.componentType)
                const componentInputLookup = componentDef?.inputs.reduce((acc: any, input: any) => {
                    acc[input.templateName] = input
                    return acc
                }, {})

                for (const attr of (element as any).attributes) {
                    //@ts-ignore
                    const input = componentInputLookup[attr.nodeName]
                    if (input) {
                        if (input.isSignal) {
                            //@ts-ignore
                            embeddedComponent.instance[input.propName] = signal(attr.nodeValue)
                        } else {
                            //@ts-ignore
                            embeddedComponent.instance[input.propName] = attr.nodeValue
                        }
                    }
                }
                this.embeddedComponents.push(embeddedComponent)
            }
        })
    }


/*
                    if (typeof embeddedComponent.instance[attr.nodeName] === 'function') {
                        //@ts-ignore
                        embeddedComponent.instance[attr.nodeName] = signal(attr.nodeValue)
                    }else {
                        //@ts-ignore
                        embeddedComponent.instance[attr.nodeName] = attr.nodeValue
                    }
                }
                this.embeddedComponents.push(embeddedComponent)
            }
        })
    }
*/

    ngDoCheck() {
        // this.embeddedComponents.forEach(comp => comp.changeDetectorRef.detectChanges())
    }

    ngOnDestroy() {
        // destroy these components else there will be memory leaks
        this.embeddedComponents.forEach(comp => comp.destroy())
        this.embeddedComponents.length = 0
    }
}